var displayPresenters = function() {
    var uuid = this.getAttribute("data-target");
    var presenterInfo = document.getElementById(uuid);
    //Get info from Card
    const name = presenterInfo.querySelector(".presenter-name-hidden").textContent;
    const title = presenterInfo.querySelector(".presenter-title-hidden").innerHTML;
    const bio = presenterInfo.querySelector(".presenter-bio-hidden").innerHTML;
    const image = presenterInfo.querySelector(".presenter-image-hidden").getAttribute("data-src");

    //push nav & footer back on open
    var bodyObj = document.body;
    bodyObj.classList.add("body--pushToBack");
    bodyObj.style.overflow = "hidden";

    const overlay = document.querySelectorAll(".modal-presenter-overlay")[0];
    const closeModal = document.querySelectorAll(".presenter-modal-close")[0];
    overlay.classList.add("active");
    // Load info into the PopUp
    overlay.querySelector(".presenter-name").textContent = name;
    overlay.querySelector(".presenter-title").innerHTML = title;
    overlay.querySelector(".presenter-bio").innerHTML = bio;
    overlay.querySelector(".presenter__image").setAttribute("data-src", image);
    overlay.querySelector(".presenter__image").setAttribute("src", image);

    closeModal.focus();

    const closeModalFn = () => {
        overlay.classList.remove("active");
        bodyObj.classList.remove("body--pushToBack");
        bodyObj.style.overflow = "auto";
    };

    closeModal.addEventListener("click", closeModalFn);
    overlay.addEventListener("click", closeModalFn);
    overlay.querySelector(".presenter-modal-wrapper").addEventListener("click", e => {
        e.stopPropagation();
    });
};

function triggerpresenterModal() {
    if (document.getElementsByClassName("presenter-more")[0]) {
        var modalTriggers = document.getElementsByClassName("presenter-more");
        Array.from(modalTriggers).forEach(function(e) {
            e.addEventListener("click", displayPresenters);
        });
    }
}

function init() {
    triggerpresenterModal();
}

export default { init };
